import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";
import { handleResponseError } from '../../../utils/helpers/network-error';

export const getOverviewData = createAsyncThunk('overview.getOverviewData', async (queryParams, { rejectWithValue }) => {
  try {
    const { data: payload } = await api.overview.getOverviewData(queryParams);
    return payload;
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});
